export default __webpack_public_path__ + "static/media/avatar_156.75edf7b1.png";